<template>
  <div class="flex flex-col justify-center sm:px-6 lg:px-8">

    <div v-if="!success">
      <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">

          <label for="code" class="block text-sm font-medium text-gray-700">
            Input your Eventbrite Order Id
          </label>
          <div class="mt-1">
            <input v-model="code" type="text" required
                   class="appearance-none block w-full px-3 py-2
               border border-gray-300 rounded-md shadow-sm placeholder-gray-400
               focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                   :class="{'is-loading': isLoading}"
            >
            <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none"
                 viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
          </div>


          <label for="email" class="block text-sm font-medium text-gray-700">
            Input your Eventbrite Email
          </label>
          <div class="mt-1 mb-2">
            <input v-model="email" type="text"
                   class="appearance-none block w-full px-3 py-2
               border border-gray-300 rounded-md shadow-sm placeholder-gray-400
               focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" placeholder="We won't store this.">
            <p class="mt-2 text-sm text-gray-500" id="email-description">Input the email associated with your Eventbrite account.</p>
          </div>
          <button v-on:click="submit"
                  class="inline-flex items-center px-6 py-3 border border-transparent shadow-sm text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
            <!-- Heroicon name: solid/mail -->
            <svg :class="{'animate-spin': isLoading}" class="-ml-1 mr-3 h-5 w-5 text-white"
                 xmlns="http://www.w3.org/2000/svg"
                 fill="none"
                 viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Check Code
          </button>

          <p class="mt-2 text-sm text-red-700">{{message}}</p>


        </div>
      </div>
    </div>

    <div v-if="success">
      <p>Success. Now <a :href="ticketUrl">go to your ticket page.</a></p>
    </div>

  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "EventbriteTicket",
  computed: {},
  props:
      {
        url: {
          type: String,
          required: true
        },
        ticketUrl: {
          type: String,
          required: true
        },

      },

  data() {
    return {
      code: '',
      email: '',
      message: '',
      evMessage: '',
      success: false,
      isLoading: false,
      csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    }
  },

  methods: {


    submit() {

      if (!this.code) {
        this.message = 'You must enter a code';
        return;
      }

      if (!this.email) {
        this.message = 'You must enter an email';
        return;
      }

      this.message = '';
      this.evMessage = '';

      this.loading = true;
      const formData = new FormData();
      formData.append('code', this.code);
      formData.append('email', this.email);
      //console.log(formData);

      // https://github.com/axios/axios/issues/960
      // https://stackoverflow.com/questions/51143730/axios-posting-empty-request
      axios.post(this.url, formData)
          //axios.get(this.url+'?code='+this.code)
          .then(response => {
            //console.log(response.data);
            this.message = response.data.message;
            this.success = true;
            this.isLoading = false;
          })
          .catch(error => {
            //console.log(error.response.data);
            this.isLoading = false;

            if (error.response) {
              this.message = error.response.data.message;
              if (error.response.status !== 401) {
                this.evMessage = 'An error has occurred. This is not an Eventzilla error. ';
                if (this.message) {
                  this.evMessage += 'Details are as follows:'
                } else {
                  this.evMessage += 'There are no details about this error. You should contact the conference organizers.';
                }
              } else {
                this.message = this.message ? this.message : 'It seems that this code is invalid.';
              }
            } else {
              this.evMessage = 'An error has occurred. This is not an Eventzilla error. ' +
                  'It is most likely caused by your browser/institution blocking the connection.' +
                  '(1) Try in a different browser or computer - even your mobile. ' +
                  '(2) Try in a different location. ' +
                  'Failing that you should contact the conference organizers.';
            }

          });

    },

  },

  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  beforeUnmount() {

  },
  unmounted() {

  }


};
</script>

<style scoped>
i {
  cursor: pointer;
  color: #e74444;
  font-size: 0.7em;
}
</style>